import { Box, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { faStar, faFlag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const LenderStoreDot: React.FC<LenderStoreDotProps> = ({ score, isFlagged, sx = {} }) => {
	let color = '#f2f2f2';

	if (isFlagged) {
		color = '#000000';
		return (
			<FontAwesomeIcon
				icon={faFlag}
				style={{
					color: color,
					display: 'inline-block',
					height: 10,
					width: 10,
				}}
			/>
		);
	}

	if (score === undefined) color = '#f2f2f2';
	else if (score >= 60) color = '#209c05';
	else if (score >= 30) color = '#85e62c';
	else if (score >= 20) color = '#ebff0a';
	else if (score >= 10) color = '#f2ce02';
	else if (score >= 0) color = '#ff0a0a';
	else color = '#ffffff';

	let borderColor = color;
	if (score && score < 0) borderColor = '#888888';

	const showStar = score && score > 100;

	if (showStar) {
		return (
			<FontAwesomeIcon icon={faStar} style={{ color: color, display: 'inline-block', height: 10, width: 10 }} />
		);
	}

	return (
		<Box
			sx={{
				backgroundColor: color,
				borderColor: borderColor,
				borderStyle: 'solid',
				borderWidth: '1px',
				display: 'inline-block',
				height: 10,
				width: 10,
				borderRadius: 180,
				...sx,
			}}
		/>
	);
};

interface LenderStoreDotProps {
	score?: number;
	isFlagged: boolean;
	sx?: SxProps<Theme>;
}
